import * as types from '../action/actionTypes';
import initialState from './initialState';

export default function TemperatureAdjustmentsReducer(state = initialState.TemperatureAdjustments, action) {
    switch (action.type) {
        case types.GET_TEMPERATURE_ADJUSTMENTS_SUCCESSFULL: return {
           ...state, TempAdjustmentsList: action.getResponse,
        };
       
        default : return state; 
    }   
}